// This is a temporary service
// Will be replace with state management library
// ngRX or ngXS
import { Injectable, EventEmitter } from '@angular/core';
import { tap } from 'rxjs/operators';
import { Subject, BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AppStateService {
    private forcedLogout: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    forcedLogout$ = this.forcedLogout.asObservable();

    private appliedFiltersChanged = new Subject<void>();
    appliedFiltersChanged$ = this.appliedFiltersChanged.asObservable();

    private applyingFilters = new Subject<void>();
    applyingFilters$ = this.applyingFilters.asObservable();

    toggleFilterPanel$: EventEmitter<void> = new EventEmitter();

    private isComparingSubject = new BehaviorSubject<boolean>(true);
    private passedDetailSubject: Subject<any> = new BehaviorSubject<any>([]);
    private isFilterPanelOpen = false;
    private isDashboardPage = new BehaviorSubject<boolean>(false);
    private applyIFrameFilters = false;

    constructor() {}

    triggerForcedLogout(message: string) {
      this.forcedLogout.next(message);
    }

    broadcastApplyingFiltersEvent() {
        this.applyingFilters.next();
    }

    setIsComparing(isComparing: boolean) {
        this.isComparingSubject.next(isComparing);
    }

    getIsComparingObservable() {
        return this.isComparingSubject.asObservable();
    }

    getpassKPIDetailsObservable() {
        return this.passedDetailSubject.asObservable();
    }

    setIsFilterPanelOpen(isFilterOpen: boolean) {
        this.isFilterPanelOpen = isFilterOpen;
    }

    getIsFilterPanelOpen() {
        return this.isFilterPanelOpen;
    }

    setIsInDashboardPage(isDashboardPage: boolean) {
        this.isDashboardPage.next(isDashboardPage);
    }

    getIsInDashboardPage() {
        return this.isDashboardPage.asObservable();
    }

    setApplyIFrameFilters(applyIFrameFilters: boolean) {
        this.applyIFrameFilters = applyIFrameFilters;
    }

    getApplyIFrameFilters() {
        return this.applyIFrameFilters;
    }
}
